import { FC } from 'react';

import WaveUIProgressDialog from '@/shared/components/dialogs/WaveUIProgressDialog';
import WaveUINotificationBar from '@/shared/components/utilities/WaveUINotificationBar';
import DialogName from '@/shared/types/dialogName.enum';

import CreateUserDialog from './components/CreateUserDialog';
import DisableCurrentUserConfirmationDialog from './components/DisableCurrentUserConfirmationDialog';
import UpdateUserDialog from './components/UpdateUserDialog';
import UsersTable_v2 from './components/UsersTable_v2/UsersTable_v2';
import useUserManagement from './hooks/useUserManagement';

const UsersManagement: FC = () => {
  const {
    refreshTableIndex,
    dialog,
    progressDialog,
    notificationBar,
    onUpdateDialogState,
    onUpdateProgressDialog,
    onUpdateNotificationBar,
    handleUpdateUser,
    handleCreateUser,
    handleToggleUserEnabled,
    handleToggleUserEnabledFromDialog,
  } = useUserManagement();

  return (
    <>
      <UsersTable_v2
        refreshTableIndex={refreshTableIndex}
        openUpdateUserModal={(user) => {
          onUpdateDialogState(DialogName.EditUser, {
            open: true,
            errors: [],
            data: user,
          });
        }}
        openCreateUserModal={() => {
          onUpdateDialogState(DialogName.CreateUser, {
            open: true,
            errors: [],
          });
        }}
        onToggleUserEnabled={({ user, shouldConfirmUpdate }) => {
          if (shouldConfirmUpdate) {
            onUpdateDialogState(DialogName.EnableUser, {
              open: true,
              data: user,
            });
            return;
          }
          void handleToggleUserEnabled(user);
        }}
      />

      {dialog?.editUser?.open && dialog.editUser.data && (
        <UpdateUserDialog
          user={dialog.editUser.data}
          onClose={() => {
            onUpdateDialogState(DialogName.EditUser, { open: false });
          }}
          onProceedUpdateUser={(user) => {
            void handleUpdateUser(user);
          }}
        />
      )}

      {dialog?.createUser?.open && (
        <CreateUserDialog
          isLoading={false}
          errors={dialog?.createUser?.errors}
          onClose={() => {
            onUpdateDialogState(DialogName.CreateUser, { open: false });
          }}
          onProceedCreateUser={(userFormValues) => {
            void handleCreateUser(userFormValues);
          }}
        />
      )}

      {dialog?.enableUser?.open && dialog.enableUser.data && (
        <DisableCurrentUserConfirmationDialog
          errors={dialog.enableUser.errors}
          user={dialog.enableUser.data}
          onClose={() => {
            onUpdateDialogState(DialogName.EnableUser, { open: false });
          }}
          onProceedDisableUser={(user) => {
            void handleToggleUserEnabledFromDialog(user);
          }}
        />
      )}

      <WaveUINotificationBar
        message={notificationBar.message}
        severity={notificationBar.severity}
        open={notificationBar.open}
        close={() => onUpdateNotificationBar({ open: false })}
      />

      <WaveUIProgressDialog
        title={progressDialog?.title}
        progress={progressDialog?.progress || 0}
        open={progressDialog?.open || false}
        onClose={() => onUpdateProgressDialog({ open: false })}
      />
    </>
  );
};

export default UsersManagement;
